export const CONSTANTS = {
	STAKE_NETWORK_ID: 1,
	CLAIM_NETWORK_ID: 43114,
	STAKE_NETWORK_NAME: "Ethereum Mainnet",
	CLAIM_NETWORK_NAME: "Avalanche Mainnet",
	NFM_CONTRACT: "0x58695a338eaa6295CBBA0097e0Cb25D9884D33E3",
	ALCHEMY_KEY: "0mZySszGgq7dmEyj5lmNDuCxG6eB8at2",
	NFM_STAKING_CONTRACT: "0x965F2495449f3c768e69869b7c4Ca6899EB79970",
	EXPLORER_URL: "https://etherscan.io",
	NFM_CLAIM_CONTRACT: "0x0e11EfadC748A5DF4Fb63106328F584745B3591e",
	REACT_CLAIM_REWARDS_API: "https://ecosystemapi.nitro.network/api/v1",
	REWARDS_EXPLORER_URL: "https://snowtrace.io",
};
